<template>
  <div
    class="notice"
    v-if="vmVisible"
    >
    <div class="notice__dialog">
      <div class='notice__dialog__header'>提示</div>
      <i class="notice__dialog__close" @click="handleHandSubmit('cancel')"></i>
      <div class="notice__dialog__txt">
        <h5 class="notice__dialog__txt__title">本竞赛已更新内容，是否立刻同步更新？</h5>
        <p class="notice__dialog__txt__info">注：后续可手动刷新页面进行更新！</p>
      </div>
      <div class='notice__dialog__btn'>
        <div
          class="notice__dialog__btn back"
          @click="handleHandSubmit('cancel')"
        >取消</div>
        <div
          class="notice__dialog__btn submit"
          @click="handleHandSubmit('submit')"
        >确认</div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  // data(){
  //   return{
  //     vmVisible:this.visible
  //   }
  // },
  computed:{
    vmVisible(){
      return this.visible
    }
  },
  methods:{
    handleHandSubmit(type){
      this.$emit('submit',{type})
    }
  }
}
</script>
<style lang="less">
.notice{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background-color:rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
}
.notice__dialog{
    width:460px;
    height:232px;
    border-radius:6px;
    background: #fff;
    position: relative;
    &__header{
      text-align: center;
      margin-top:24px;
      font-size: 24px;
      font-weight: 500;
    }
    &__txt{
      text-align: center;
      margin-top:30px;
      font-size: 16px;
      &__title{
        font-size: 14px;
        font-weight: normal;
        padding: 0;
        margin: 0;
      }
      &__info{
        padding: 0;
        margin: 0;
        font-size: 14px;
        color:#666666;
      }
    }
    &__btn{
    display: flex;
    justify-content: center;
    margin-top:40px;
    .notice__dialog__btn{
      margin:0 10px;
      width: 140px;
      height: 40px;
      line-height: 38px;
      border-radius:20px;
      border:2px solid rgba(252,235,203,1);
      box-sizing: border-box;
      cursor: pointer;
      &.back{
        background: #FCEBCB;
        color:#333333;
      }
      &.submit{
        color: #fff;
        background: #4B7635;
      }
    }
  }
  &__close{
    width: 18px;
    height: 18px;
    background: url('~@/assets/images/close.png') no-repeat center;
    background-size:18px 18px ;
    position: absolute;
    right:10px;
    top:10px;
    cursor: pointer;
  }
}
  
  .notice__dialog__txt{
    h5{
      color:#333;
      width: 318px;
      margin:0 auto;
    }
  }
  .notice--dialog-icon{
    width: 50px;
    height: 50px;
    margin-top:32px;
    background: url('~@/assets/mark_icon.png') no-repeat center;
    background-size:50px 50px ;

  }
</style>